/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/

import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { Divider, Drawer } from "@material-ui/core";
// import DashboardIcon from "@material-ui/icons/Dashboard";
import PeopleIcon from "@material-ui/icons/People";
// import AccountBoxIcon from "@material-ui/icons/AccountBox";
import SettingsIcon from "@material-ui/icons/Settings";
// import LockOpenIcon from "@material-ui/icons/Lock";
import { MdPersonSearch, MdViewList, MdPreview, MdImage } from "react-icons/md";
import { FaHandHoldingMedical } from "react-icons/fa";
import { FaRegImages } from "react-icons/fa";

import { Profile, SidebarNav } from "./components";
// offlinedb
import { PlaylistAdd, GridOn } from "@material-ui/icons";

//import { getConstantValue } from 'typescript';
//theme
import palette from "theme/palette";
import { isFeatureEnabled, isMlEntitlementEnabled, isAiAnnotationAllowed } from "realtime/entitlementMode";

const themeName = "orangeTheme";
const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 240,

    backgroundColor: theme.palette.secondary.main,
    // border:"none",
    // overflow:'hidden',
    [theme.breakpoints.up("tablet")]: {
      marginTop: 64,
      height: "calc(100% - 64px)",
    },
    [theme.breakpoints.down("tablet")]: {
      width: 170,
    },
  },
  drawerMini: {
    width: 70,
    overflow: "hidden",
    [theme.breakpoints.up("tablet")]: {
      marginTop: 64,
      height: "calc(100% - 64px)",
    },
  },
  root: {
    // backgroundColor:"#030e31",
    backgroundColor: theme.palette.secondary.main,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    // overflowY:"auto",
    padding: theme.spacing(1),
  },
  profile: {
    width: "100%",
    textAlign: "center",
    fontSize: "16px",
  },
  divider: {
    margin: theme.spacing(2, 0),
    background: "#fff",
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
}));

const Sidebar = (props) => {
  const {
    open,
    variant,
    onClose,
    className,

    isViewimagesActive,
    orgzFeatures,
    ...rest
  } = props;

  const {
    bulk_upload: isBulkUploadActive,
    bulk_upload_for_patient: isBulkUploadForPatientActive,
    doc_annotation_patient: isDocAnnotationPatientActive,
    patient_upload: ispatientUploadActive,
    report_download: isReportDownloadActive,
    report_share: isReportShareActive,
    review_images: isReviewImagesActive,
    review_patients: isReviewPatientsActive,
    trigger_review_for_image: isTriggerReviewForImageActive,
    trigger_review_for_patient: isTriggerReviewForPatientActive,
    view_images: isViewImagesActive,
    view_patient: isViewPatientActive,
    view_patients_from_bulk_upload: isViewPatientsFromBulkUploadActive,
  } = orgzFeatures;
  const classes = useStyles();
  const userIsReviewerForCurrentOrg =
    props.userStore?.userProfile?.review_orgz_list?.length;
  const isCurrentUserAConsultant =
    props?.userStore?.userProfile?.consultantDetails?.isCurrentUserAConsultant;
  const mlEntitlementEnabled = isMlEntitlementEnabled(
    props?.userStore?.userProfile?.no_ai_annotation
  );

  const pages = [
    // {
    //   title: 'Home',
    //   href: '/dashboard',
    //   icon: <DashboardIcon />
    // },

    props.orgzFeatures && ispatientUploadActive && !isCurrentUserAConsultant
      ? {
          title: "Patient Upload",
          href: "/patients",
          icon: <PeopleIcon />,
        }
      : null,
    props.orgzFeatures && isViewPatientActive && !isCurrentUserAConsultant
      ? {
          title: "View Patients",
          href: "/view-patients",
          icon: <MdPersonSearch style={{ fontSize: "1.5rem" }} />,
          // icon: <SettingsIcon />,
        }
      : null,
    props.orgzFeatures &&
    userIsReviewerForCurrentOrg &&
    isReviewPatientsActive &&
    !isCurrentUserAConsultant
      ? {
          title: "Review Patients",
          href: "/review-patients",
          icon: <MdPreview style={{ fontSize: "1.5rem" }} />,
        }
      : null,
    props.orgzFeatures &&
    isCurrentUserAConsultant &&
    isDocAnnotationPatientActive
      ? {
          title: "Doc Review",
          href: "/doctor-review",
          icon: <FaHandHoldingMedical style={{ fontSize: "1.5rem" }} />,
        }
      : null,
    // {
    //   title: 'Products',
    //   href: '/products',
    //   icon: <ShoppingBasketIcon />
    // },
    // {
    //   title: 'Authentication',
    //   href: "/sign-in",
    //   icon: <LockOpenIcon />
    // },
    // {
    //   title: 'Typography',
    //   href: '/typography',
    //   icon: <TextFieldsIcon />
    // },
    // {
    //   title: 'Icons',
    //   href: '/icons',
    //   icon: <ImageIcon />
    // },
    mlEntitlementEnabled &&
    props.orgzFeatures &&
    (isFeatureEnabled(isBulkUploadActive) || isFeatureEnabled(isBulkUploadForPatientActive)) &&
    !isCurrentUserAConsultant
      ? {
          title: "Bulk Upload",
          href: "/bulk-upload",
          icon: <PlaylistAdd />,
        }
      : null,
      isAiAnnotationAllowed(props?.userStore?.userProfile?.no_ai_annotation) && props.orgzFeatures &&
    isViewPatientsFromBulkUploadActive &&
    !isCurrentUserAConsultant
      ? {
          title: "View Patients BU",
          href: "/view-patients-bu",
          icon: <FaRegImages style={{ fontSize: "1.5rem" }} />,
          // icon: <SettingsIcon />,
        }
      : null,
      props.orgzFeatures && isViewImagesActive && !isCurrentUserAConsultant
      ? {
          title: "View Images",
          href: "/view-images",
          icon: <MdViewList style={{ fontSize: "1.5rem" }} />,
        }
      : null,
    props.orgzFeatures &&
    userIsReviewerForCurrentOrg &&
    isReviewImagesActive &&
    !isCurrentUserAConsultant
      ? {
          title: "Review Images",
          href: "/review-images",
          icon: <MdImage style={{ fontSize: "1.5rem" }} />,
        }
      : null,
    !isCurrentUserAConsultant
      ? {
          title: "Settings",
          href: "/settings",
          icon: <SettingsIcon />,
        }
      : null,
      // {
      //   title: "Help Menu",
      //   href: "/help-menu",
      //   icon: <SettingsIcon />,
      // },
    // {
    //   title: 'Logout',
    //   href: "/sign-in",
    //   icon: <LockOpenIcon />
    // }
  ].filter((page) => page);
  // : [
  //     // {
  //     //   title: 'Home',
  //     //   href: '/dashboard',
  //     //   icon: <DashboardIcon />
  //     // },

  //     {
  //       title: "Patient Upload",
  //       href: "/patients",
  //       icon: <PeopleIcon />,
  //     },
  //     {
  //       title: "View Patients",
  //       href: "/view-patients",
  //       icon: <MdPersonSearch style={{ fontSize: "1.5rem" }} />,
  //       // icon: <SettingsIcon />,
  //     },

  //     // {
  //     //   title: 'Products',
  //     //   href: '/products',
  //     //   icon: <ShoppingBasketIcon />
  //     // },
  //     // {
  //     //   title: 'Authentication',
  //     //   href: "/sign-in",
  //     //   icon: <LockOpenIcon />
  //     // },
  //     // {
  //     //   title: 'Typography',
  //     //   href: '/typography',
  //     //   icon: <TextFieldsIcon />
  //     // },
  //     // {
  //     //   title: 'Icons',
  //     //   href: '/icons',
  //     //   icon: <ImageIcon />
  //     // },
  //     {
  //       title: "Bulk Upload",
  //       href: "/bulk-upload",
  //       icon: <PlaylistAdd />,
  //     },
  //     {
  //       title: "View Images",
  //       href: "/view-images",
  //       icon: <MdViewList style={{ fontSize: "1.5rem" }} />,
  //     },

  //     {
  //       title: "Settings",
  //       href: "/settings",
  //       icon: <SettingsIcon />,
  //     },
  //     // {
  //     //   title: 'Logout',
  //     //   href: "/sign-in",
  //     //   icon: <LockOpenIcon />
  //     // }
  //   ];

  // const getValue = (data) => {
  //   let Arr = data.split(",");
  //   return Arr;
  // };
  // const arrayToObject = (array) =>
  //   array.reduce((obj, item) => {
  //     obj[item.property] = item.value;
  //     return obj;
  //   }, {});
  return (
    <Drawer
      anchor="left"
      classes={{
        paper: props.sidebarMini ? classes.drawerMini : classes.drawer,
      }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        {!props.sidebarMini ? (
          <div className={classes.profile}>
            <Profile sidebarMini={props.sidebarMini} />
            <Divider className={classes.divider} />
          </div>
        ) : (
          <div className={classes.profile}>
            <Profile sidebarMini={props.sidebarMini} />
            <Divider className={classes.divider} />
          </div>
        )}
        <SidebarNav
          className={classes.nav}
          pages={pages}
          sidebarMini={props.sidebarMini}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};
function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
    patientStore: store.patientStore,
    userStore: store.userStore,
    // orgzFeatures: store.globalStore?.orgzFeatures,
    orgzFeatures: store.globalStore?.orgzFeatures || {
      bulk_upload: 0,
      bulk_upload_for_patient: 0,
      doc_annotation_patient: 0,
      patient_upload: 0,
      report_download: 0,
      report_share: 0,
      review_images: 0,
      review_patients: 0,
      trigger_review_for_image: 0,
      trigger_review_for_patient: 0,
      view_images: 0,
      view_patient: 0,
      view_patients_from_bulk_upload: 0,
    },
  };
}
export default connect(mapStateToProps, {})(Sidebar);
